import React, { Component, Fragment } from 'react';

class ModalConfirm extends Component {

    state = {
        load: false,
    }

    componentDidMount() {

    }

    confirmModal = () => {
        this.setState({load:true});
        this.props.function();
        setTimeout(() => {
            document.getElementById("close-modal-confirm").click();
        }, 2000);
    }

    render() {
        return (
            <Fragment>
                <div id="modal-confirm" data-toggle="modal" data-target=".modal-confirm"></div>
                <div className="modal fade modal-confirm" data-backdrop="static" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="myLargeModalLabel">
                                    {this.props.title}
                                </h5>
                                <button type="button" className="close" data-dismiss="modal" aria-hidden="true">×</button>
                            </div>
                            <div className="modal-body">
                                <div className="row">
                                    <div className="col-md-12">
                                        {this.props.msg}
                                    </div>

                                    {(this.props.msgError)?
                                    <div className="col-md-12 p-t-20">
                                        <div className="alert alert-danger">
                                        {this.props.msgError}
                                        </div>
                                    </div>
                                    :null}
                                </div>
                            </div>
                            <div className="modal-footer">
                                {(this.props.load || this.load) ? <i className="fa fa-spin fa-spinner"></i> :
                                <button className="col-md-2 btn waves-effect waves-light btn-rounded btn-success" onClick={this.confirmModal}>
                                    Confirmar
                                </button>
                                }
                                <button id="close-modal-confirm" type="button" className="col-md-2 closeModal btn btn-secondary btn-rounded waves-effect" data-dismiss="modal">Fechar</button>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment >
        )
    }

}

export default ModalConfirm;